import { render } from "./HomeFooter.vue?vue&type=template&id=8f4b8acc&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=8f4b8acc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4b8acc"]])

export default __exports__